<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;">
      <a-form-item>
        <a-radio-group v-model="type" button-style="solid" @change="changeTag()">
          <a-radio-button value="1">
            待我处理（{{ noHandleCount }}）
          </a-radio-button>
          <a-radio-button value="2">
            我的申请
          </a-radio-button>
          <a-radio-button value="3">
            我处理的
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button icon="plus" type="primary" primary html-type="submit" @click="clickApply()">产品申请</a-button>
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" :data-source="tableData" style="background: #ffffff;" :loading="tableLoad"
      :rowKey="item => item.id" bordered :pagination="false">

      <template slot="status" slot-scope="text">
        <a-tag color="red" v-if="text == 0">待处理</a-tag>
        <a-tag color="green" v-if="text == 1">已同意</a-tag>
        <a-tag color="grey" v-if="text == 2">已拒绝</a-tag>
      </template>

      <template slot="handle" slot-scope="text,recode">
        <a-button type="primary" primary v-if="recode.status == 0 && type == 1" @click="clickReview(recode, 1)">同意
        </a-button>
        <a-button type="danger" danger v-if="recode.status == 0 && type == 1" @click="clickReview(recode, 2)">拒绝
        </a-button>
      </template>
      <template slot="footer">
        <a-pagination v-model="page" style="text-align: right" show-size-changer :total="count" :page-size="page_size"
          @change="changePage" @showSizeChange="changePage" />
      </template>
    </a-table>

    <ApplyDialog :show-dialog="applyDialogShow" :reviewUser="reviewUser" :appList="appList"
      @close-dialog="closeDialog()"></ApplyDialog>
  </div>
</template>

<script>
import { GetAppList, GetApplyPage, ApplyHandle, ApplyReviewer } from "@/api/v1/app_api";
import ApplyDialog from "@/components/V1/ApplyDialog";

export default {
  name: "Apply",
  components: { ApplyDialog },
  data() {
    return {
      type: "1",
      appList: [],
      tableData: [],
      count: 100,
      page: 1,
      page_size: 10,
      tableLoad: false,
      applyDialogShow: false,
      quitUserInfo: {},
      reviewUser: [],
      noHandleCount: 0,
    }
  },
  mounted() {
    this.init_data()
  },
  computed: {
    getTableColumns() {
      let _table_columns = [
        { title: '申请人', dataIndex: 'user_name', scopedSlots: { customRender: 'user_name' }, },
        { title: '申请应用', dataIndex: 'name', scopedSlots: { customRender: 'name' }, },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
        { title: '申请时间', dataIndex: 'create_time', scopedSlots: { customRender: 'create_time' }, },
        { title: '操作', dataIndex: 'handle', scopedSlots: { customRender: 'handle' } },
      ]
      return _table_columns
    }
  },
  methods: {
    init_data() {
      if (this.tableLoad) return
      this.tableLoad = true
      GetApplyPage({
        type: this.type,
        page: this.page,
        page_size: this.page_size
      }).then(resp => {
        this.tableLoad = false
        if (resp.code === 200) {
          this.tableData = resp.data.list
          this.count = parseInt(resp.data.count)
          this.page = parseInt(resp.data.page)
          this.page_size = parseInt(resp.data.page_size)
          this.noHandleCount = parseInt(resp.data.noHandleCount)
        }
      })
    },
    changePage(page, page_size) {
      this.page = page
      this.page_size = page_size
      this.init_data()
    },
    changeTag() {
      this.page = 1
      this.init_data()
    },
    closeDialog() {
      this.applyDialogShow = false
      this.init_data()
    },
    clickReview(info, status) {
      let data = {
        "id": info.id,
        "status": status,
      }
      ApplyHandle(data).then(resp => {
        if (resp.code === 200) {
          this.$message.success(resp.msg)
          this.init_data()
        } else if (resp.code === 3001) {
          this.$error({
            title: '提示',
            content: resp.msg,
          });
        } else {
          this.$message.success(resp.msg)
        }
      })

    },

    clickApply() {
      GetAppList({}).then(resp => {
        this.dataLoad = false
        if (resp.code === 200) {
          this.appList = resp.data
          this.applyDialogShow = true
        }
      })
    },

  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/System/Application/Apply.vue